// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBoesLwIKBrDeH55VkGGyuvx94CFqGY9lk",
  authDomain: "sarayli-moda-687ab.firebaseapp.com",
  databaseURL: "https://sarayli-moda-687ab-default-rtdb.firebaseio.com",
  projectId: "sarayli-moda-687ab",
  storageBucket: "sarayli-moda-687ab.firebasestorage.app",
  messagingSenderId: "917101393687",
  appId: "1:917101393687:web:2d3f1199af5d99d46aa952",
  measurementId: "G-7CFPYB5BCH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// --- Analytics ---
//
// KVKK geregi olcumleme cerezleri kullanicinin acik onayi olmadan
// calistirilmamali. Eskiden getAnalytics her sayfa yuklenisinde kosulsuz
// cagriliyordu; artik yalnizca kullanici cerez bandinda onay verdiginde
// baslatiliyor.
let analytics: ReturnType<typeof getAnalytics> | undefined;

export function initAnalytics() {
  if (typeof window === 'undefined') return undefined;
  if (analytics) return analytics;

  try {
    analytics = getAnalytics(app);
    return analytics;
  } catch (error) {
    console.error('Analytics baslatilamadi:', error);
    return undefined;
  }
}

export { analytics };

export default app;
